import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  /* wrapper properties */
  background-color: white;
  text-align: center;
  padding-top: 5rem;
`;

export const StyledContainer = styled(Container)`
  width: 80%;
  p {
    text-align: left;
  }
`;

export const Name = styled.h1`
  font-size: 56px;
  margin-bottom: 0.75rem;

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    font-size: 36px;
  }
`;

export const Title = styled.h2`
  font-size: 18px;
  color: #ff5c0b;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const ProfileImage = styled(Image)`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
`;

export const StyledLink = styled(Link)`
  align-self: center;
`;
